import type { ZodType } from "zod";
import { z } from "zod";

import { selectionSourceSchema } from "./selection-source";
import type { Locale } from "./locale";

export const createLocaleSelectionSchema = <T extends Locale>(localeSchema: ZodType<T>) =>
	z.object({
		locale: localeSchema,
		source: selectionSourceSchema,
	});

export type LocaleSelection<TLocale extends Locale = Locale> = z.infer<
	ReturnType<typeof createLocaleSelectionSchema<TLocale>>
>;
